import { FC } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { theme } from '@theme';
import { HelpCenterQuestion } from './HelpCenter';
import * as styles from './HelpCenterQuestionItem.styles';
import { MarkdownRenderer } from '../MarkdownRenderer/MarkdownRenderer';
import caretDownIllustration from '@images/helpCenterQuestionItem__caretDown.svg';
import Img from '@barracuda/shared/components/Primitive/Img';

interface HelpCenterQuestionItemProps {
  readonly question: HelpCenterQuestion;
  readonly expanded?: boolean;
  readonly onClick: () => void;
  readonly categoryId: number;
}

export const HelpCenterQuestionItem: FC<HelpCenterQuestionItemProps> = ({
  question,
  expanded,
  onClick,
  categoryId
}) => {
  const CaretDownIcon = () => <Img src={caretDownIllustration} alt='' aria-hidden />;

  return (
    <Accordion
      id={`question-item-${categoryId}-${question.questionId}`}
      expanded={expanded}
      sx={styles.helpCenterQuestionItem}
      key={`question-item-${categoryId}-${question.questionId}-accordion`}
      onChange={onClick}
    >
      <AccordionSummary
        expandIcon={<CaretDownIcon />}
        aria-controls={`panel-${categoryId}-${question.questionId}-content`}
        id={`panel-${categoryId}-${question.questionId}-header`}
        sx={{ padding: 0 }}
      >
        <Typography sx={{ color: theme.palette.common.primaryDark, fontWeight: 600 }}>
          {question.questionLabel}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <MarkdownRenderer markdown={question.text} sx={styles.helpCenterQuestionItemDetails} />
      </AccordionDetails>
    </Accordion>
  );
};
